import modStyl from './subjectInfo.module.scss'

import React, { useMemo } from "react"
import { InfoOutlined } from '@ant-design/icons';
import { readTenantConfiguration } from '../../../../../../utils/storage';

type Props = {
  subjectName: string;
  patientNo: string;
}

// newCrm=1 项目的手写姓名缩写展示（只读，不含手机号与编辑按钮）
const SubjectNameInfo:React.FC<Props> = ({subjectName, patientNo})=> {

  const label = useMemo(()=> readTenantConfiguration('label'), [])

  return (
    <div className={modStyl.container}>
      <div className={modStyl.header}>
          <div className={modStyl.west}>
            <InfoOutlined/>
            {label}信息
          </div>
      </div>
      <div className={modStyl.content}>
        <dl>
          <dt>患者编号：</dt>
          <dd>{patientNo ? patientNo : '---'}</dd>
        </dl>
        <dl>
          <dt>姓名缩写：</dt>
          <dd>{subjectName ? subjectName : '---'}</dd>
        </dl>
      </div>
    </div>
  )
}

export default SubjectNameInfo
